import { render, staticRenderFns } from "./sysMenuView.vue?vue&type=template&id=ed2b9a10&scoped=true&"
import script from "./sysMenuView.vue?vue&type=script&lang=js&"
export * from "./sysMenuView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2b9a10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed2b9a10')) {
      api.createRecord('ed2b9a10', component.options)
    } else {
      api.reload('ed2b9a10', component.options)
    }
    module.hot.accept("./sysMenuView.vue?vue&type=template&id=ed2b9a10&scoped=true&", function () {
      api.rerender('ed2b9a10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/sysMenu/sysMenuView.vue"
export default component.exports